export const Constants = {
  TAG_NAME: 'pop-example-page-component',
} as const;
